<template>
	<div class="tuto">
		<div v-show="!highlight" class="bg"></div>

		<div v-show="highlight && highlight_style" class="highlight">
			<div class="hole" :style="highlight_style" v-hammer:tap="tap_highlight"></div>
		</div>

		<transition name="boss">
			<div class="boss">
				<div class="illustration" v-bg="'heroes/boss.png'"></div>
				<transition name="bubble" mode="out-in">
					<div class="bubble-wrap" :key="current_step.index">
						<div class="bubble" v-bg="'heroes/bubble.png'" v-hammer:tap="next">
							<div class="name" v-bg="'tooltip-title.png'">Zany</div>
							<div class="text">
								<ui-text :text="current_step[lang]" />
							</div>
							<div class="next-button">></div>
						</div>
					</div>
				</transition>
			</div>
		</transition>

		<!-- <transition name="bubble" mode="out-in" appear>
			<div v-if="current_step" class="bubble" :key="current_step.index" :class="bubble_position">
				<div class="bubble-content">
					<ui-text class="text" :text="current_step[lang]" />
					<ui-button class="button" v-hammer:tap="next">{{ button_text | lang }}</ui-button>
				</div>
			</div>
		</transition> -->

		<div class="skip" v-hammer:tap="skip_tuto">{{ 'skip_tuto' | lang }}</div>

	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import Sounds from '@/js/sounds'
import UiText from '@/components/ui/ui-text'

export default {
	name: 'tuto',
	data() {
		return {
			index: -1,
			highlight: null,
		}
	},
	props: {
		tuto: { default: null }
	},
	computed: {
		...mapGetters([ 'lang', 'user' ]),
		button_text() {
			return this.current_step && this.current_step.button && this.current_step.button.text ? this.current_step.button.text : 'next'
		},
		current_step() {
			return this.index > -1 && this.tuto.steps.length > this.index ? { ...this.tuto.steps[this.index], index: this.index } : null
		},
		bubble_position() {
			if (this.current_step) return this.current_step.position
			return 'middle'
		},
		highlight_style() {
			if (this.current_step && this.current_step.highlight && this.highlight) {
				const border = this.current_step.highlight_border !== undefined ? this.current_step.highlight_border : 8
				return {
					left: (this.highlight.x - border) + 'px',
					top: (this.highlight.y - border) + 'px',
					width: (this.highlight.width + border * 2) + 'px',
					height: (this.highlight.height + border * 2) + 'px'
				}
			}
			return {}
		},
	},
	watch: {
		index: {
			handler() {
				this.highlight = null
				if (this.tuto.steps.length <= this.index) {
					this.end_tuto()
				}
				if (this.current_step) {
					if (this.current_step.highlight) {
						const el = document.querySelector(this.current_step.highlight)
						if (el) this.highlight = el.getBoundingClientRect()
					} else
						this.highlight = null
				}
					
			},
			immediate: true
		}
	},
	methods: {
		tap_highlight() {
			if (this.current_step.tap) {
				const el = document.querySelector(this.current_step.tap)
				if (el && el.hammer && el.hammer.handlers && el.hammer.handlers.tap) {
					el.hammer.handlers.tap[0]({ srcEvent: {} })
				}
			}
			this.next()
		},
		next() {
			if (this.current_step && this.current_step.button && this.current_step.button.method) {
				this[this.current_step.button.method]()
			}
			if (this.index > -1) Sounds.play('button')
			this.index++
		},
		end_tuto() {
			this.$store.commit('EDIT_USER_STATE', { viewed_tutos: [ ...this.user.viewed_tutos, this.tuto.slug ] })
			this.$store.commit('EDIT_APP_STATE', { tuto: null })
		},
		skip_tuto() {
			Sounds.play('button')
			this.end_tuto()
		},
		keypress(e) {
			if (e.keyCode === 27) {
				this.next()
			}
		},
	},
	mounted() {
		setTimeout(() => {
			this.next()
		}, 750)
	},
	created() {
		window.addEventListener('keyup', this.keypress)
	},
	beforeDestroy() {
		window.removeEventListener('keyup', this.keypress)
	},
	components: { UiText }
}
</script>

<style lang="stylus" scoped>
.tuto
	fixed 0
	z-index 1
	transition opacity 0.5s easeOutQuart
	&.tuto-enter, &.tuto-leave-to
		opacity 0
		.boss
			transform translateX(64px)
			opacity 0
			.bubble-wrap
				opacity 0
				transform translate(64px, 32px) scale(0.9) rotate(-2deg)
	&.tuto-enter-active
		.boss
			.bubble-wrap
				transition 0.25s easeOutBack 0.5s
	.bg
		absolute 0
		background-color alpha(#000, 80%)
	.highlight
		absolute 0
		.hole
			position absolute
			box-shadow 0 0 0 9999px alpha(#000, 80%)
			transition 0.5s easeOutQuart
			border-radius 8px

	.boss
		position absolute
		right -32px
		bottom -8px
		z-index 1
		transition 0.25s easeOutQuart
		.illustration
			width (517px / 1.1)
			height (909px / 1.1)
			background-size contain
		.bubble-wrap
			position absolute
			right 440px
			top -180px
			width (1375px / 1.5)
			min-height (427px / 1.5)
			transition 0.25s easeOutBack
			transform-origin bottom right
			&.bubble-enter
				transform translate(64px, 32px) scale(0.9) rotate(-2deg)
				opacity 0
			&.bubble-leave-to
				transform translate(-32px, -16px) scale(1) rotate(2deg)
				opacity 0
			.bubble
				// absolute 0
				background top center no-repeat
				background-size 100% 100%
				text-align center
				flex center center
				// padding 0px 0 22% 0
				color dark
				font-size 4rem
				line-height 0.8em
				.name
					position absolute
					left 80px
					top -20px
					width round(393px / 2)
					height round(84px / 2)
					font-size 4rem
					background center center no-repeat
					background-size contain
				.text
					padding 40px 32px 148px 32px
			.next-button
				position absolute
				right 0
				top 40%
				background-color #fff
				color dark
				width 40px
				height 40px
				flex center center
				border-radius 50%
				animation next-button 0.5s easeInOutSine infinite alternate
					
	.skip
		position absolute
		left 32px
		top 40px
		height 40px
		padding 0 16px
		font-size 4rem
		line-height @height
		color #fff
		opacity 0.75
		&:hover
			opacity 1


@keyframes next-button
	0%
		transform scale(1)
	100%
		transform scale(1.1)

</style>
